// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取CP二维码列表 GET /cp-info/qr-list */
export async function getCpQrList(
    params: API.CpQrListParams,
    options?: { [key: string]: any },
) {
    return request<API.CpQrListResult>('/qr', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    });
}

/** 创建CP二维码 POST /cp-info/qr */
export async function createCpQr(
    data: API.CreateCpQrParams,
    options?: { [key: string]: any },
) {
    return request<API.CpQrResult>('/qr', {
        method: 'POST',
        data: {
            ...data,
            cp_id: Number(data.cp_id), // Convert BigInt to number for API
        },
        ...(options || {}),
    });
}

/** 更新CP二维码 PUT /cp-info/qr/:id */
export async function updateCpQr(
    id: string,
    data: API.UpdateCpQrParams,
    options?: { [key: string]: any },
) {
    return request<API.CpQrResult>(`/qr/${id}`, {
        method: 'PUT',
        data,
        ...(options || {}),
    });
}

/** 绑定二维码到订单 POST /qr/bind-order */
export async function bindOrderQr(
    data: { order_no: string; qr_id: string },
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<any>>('/qr/bind-order', {
        method: 'POST',
        data,
        ...(options || {}),
    });
}

/** 获取码商信息 GET /user/info */
export async function getUserInfo(options?: { [key: string]: any }) {
    return request<API.CpInfoResult>('/user/info', {
        method: 'GET',
        ...(options || {}),
    });
}

/** 删除CP二维码 DELETE /qr/:id */
export async function deleteCpQr(
    id: string,
    options?: { [key: string]: any },
) {
    return request<API.StandardResponse<null>>(`/qr/${id}`, {
        method: 'DELETE',
        ...(options || {}),
    });
}

/** 修改密码 POST /user/change-password */
export async function changePassword(
    data: API.ChangePasswordDto,
    options?: { [key: string]: any }
) {
    return request<API.ChangePasswordResult>('/user/change-password', {
        method: 'Put',
        data,
        ...(options || {}),
    });
} 